<div class="PopupContainer">
    <mat-card class="mat-elevation-z8 nopad PopupContentContainer">
        <img class="cardImage" src="{{baseUrl}}" alt="">
    </mat-card>
</div>